// 常量替代 mutation 事件类型
export const ADD_CURRENT_USER = 'ADD_CURRENT_USER'
// 添加用户登录信息
export const ADD_USER_LOGIN_INFO = 'ADD_USER_LOGIN_INFO'
// 添加动态路由信息
export const ADD_ASYNC_ROUTERS = 'ADD_ASYNC_ROUTERS'
// 添加所有资源列表
export const ADD_ALL_PERMISSION_LIST = 'ADD_ALL_PERMISSION_LIST'
// 添加角色列表
export const ADD_SYS_ROLE_LIST = 'ADD_SYS_ROLE_LIST'
// 添加用户基本信息
export const ADD_USER_BASE_INFO = 'ADD_USER_BASE_INFO'
// 清空用户基本信息
export const CLEAR_USER_BASE_INFO = 'CLEAR_USER_BASE_INFO'
// 添加订单详情
export const ADD_ORDER_DETAIL_DATAS = 'ADD_ORDER_DETAIL_DATAS'
// 添加订单详情数据（订单表）
export const ADD_ORDER_DETAIL_DATA = 'ADD_ORDER_DETAIL_DATA'
// 添加用户状态字典表信息
export const ADD_USER_STATUS_DIC_LIST = 'ADD_USER_STATUS_DIC_LIST'
// 添加医生学位字典表信息
export const ADD_DOCTOR_DEGREE_DIC_LIST = 'ADD_DOCTOR_DEGREE_DIC_LIST'
// 添加医生职称字典表信息
export const ADD_DOCTOR_TITLE_DIC_LIST = 'ADD_DOCTOR_TITLE_DIC_LIST'
// 添加医院等级字典表信息
export const ADD_HOSPITAL_DEGREE_DIC_LIST = 'ADD_HOSPITAL_DEGREE_DIC_LIST'
// 添加医院名称ID列表
export const ADD_HOSPITAL_NAME_ID_LIST = 'ADD_HOSPITAL_NAME_ID_LIST'
// 添加公司名称ID列表
export const ADD_COMPANY_NAME_ID_LIST = 'ADD_COMPANY_NAME_ID_LIST'
// 修改当前管理员注册执行步骤
export const EDIT_ADMIN_REGISTER_STEP = 'EDIT_ADMIN_REGISTER_STEO'
// 添加管理员注册的用户信息
export const ADD_ADMIN_REGISTER_USER_INFO = 'ADD_ADMIN_REGISTER_USER_INFO'
// 添加积分状态
export const ADD_POINT_STATUS = 'ADD_POINT_STATUS'
// 添加积分操作类型
export const ADD_POINT_HANDLE_TYPE = 'ADD_POINT_HANDLE_TYPE'
// 添加医院状态字典表信息
export const ADD_HOSPITAL_STATUS_LIST = 'ADD_HOSPITAL_STATUS_LIST'
// 添加提现状态字典表信息
export const ADD_WITHDRAW_STATUS_DIC_LIST = 'ADD_WITHDRAW_STATUS_DIC_LIST'
// 设置正在审核的提现ID
export const ADD_AUDIT_WITHDRAW_ID = 'ADD_AUDIT_WITHDRAW_ID'
// 添加医生状态字典表信息
export const ADD_DOCTOR_STATUS_LIST = 'ADD_DOCTOR_STATUS_LIST'
// 添加订单状态字典表信息
export const ADD_ORDER_STATUS_LIST = 'ADD_ORDER_STATUS_LIST'
// 添加订单病理类型字典表信息
export const ADD_ORDER_PATHOLOGY_TYPE_LIST = 'ADD_ORDER_PATHOLOGY_TYPE_LIST'
// 添加食道筛订单状态字典表
export const ADD_ESOPHAGUS_STATUS_DIC_LIST = 'ADD_ESOPHAGUS_STATUS_DIC_LIST'
// 添加食道筛订单来源字典表
export const ADD_ESOPHAGUS_FROM_DIC_LIST = 'ADD_ESOPHAGUS_FROM_DIC_LIST'
// 添加食道筛产品状态字典表
export const ADD_EPS_SN_STATUS_DIC_LIST = 'ADD_EPS_SN_STATUS_DIC_LIST'
// 添加实验室列表
export const ADD_LAB_NAME_ID_LIST = 'ADD_LAB_NAME_ID_LIST'
// 添加快递付款方式字典表
export const ADD_EXPRESS_PAY_METHOD_DIC_LIST = 'ADD_EXPRESS_PAY_METHOD_DIC_LIST'
// 添加快递单位字典表
export const ADD_EXPRESS_DIC_LIST = 'ADD_EXPRESS_DIC_LIST'
// 添加收货方式字典表
export const ADD_RECEIVING_TYPE_DIC_LIST = 'ADD_RECEIVING_TYPE_DIC_LIST'
// 添加怡早学订单详情记录类型字典表
export const ADD_RECORD_TYPE_DIC_LIST = 'ADD_RECORD_TYPE_DIC_LIST'
// 添加代理商列表，用于下拉查询
export const ADD_AGENT_LIST = 'ADD_AGENT_LIST'
// 添加微信公众号菜单
export const ADD_WECHAT_MENU_URL = 'ADD_WECHAT_MENU_URL'



// WEBPACK FOOTER //
// ./src/store/modules/mutation-types.js